import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";

export default function AuthCallback() {
  const nav = useNavigate();
  const { finalizeGoogle } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) { nav("/auth"); return; }
    (async () => {
      try {
        await finalizeGoogle(decodeURIComponent(m[1]));
        // clear hash
        window.history.replaceState(null, "", window.location.pathname);
        nav("/laboratory");
      } catch {
        nav("/auth");
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div data-testid="auth-callback" style={{ padding: "20vh 0", textAlign: "center" }}>
      <div className="overline">Authenticating...</div>
      <div className="font-serif" style={{ marginTop: 14, fontSize: 28, color: "var(--brass)" }}>
        Opening the gate...
      </div>
    </div>
  );
}
